/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UpdateChatMessageRequest1FromJSON(json) {
    return UpdateChatMessageRequest1FromJSONTyped(json, false);
}
export function UpdateChatMessageRequest1FromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        message: !exists(json, 'message') ? undefined : json['message']
    };
}
export function UpdateChatMessageRequest1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        message: value.message
    };
}
